<template>
  <div>
    <label class="pb-2">{{field.etiqueta}}</label>
    <v-row :style="{ width: width + 'px', height: height + 'px' }" class="container-autograph-signature">
      <canvas 
        ref="signatureRef"
        v-if="showElementsHtml && !contentVideoTaken && !showSignatureImage"
        class="container-signature"
        @mousedown="startDrawing"
        @mousemove="draw"
        @mouseup="stopDrawing"
        @mouseleave="stopDrawing"
        @touchstart="startDrawing"
        @touchmove="draw"
        @touchend="stopDrawing"
        @touchcancel="stopDrawing"
        :width="width"
        :height="height"
      />
      <div class="loader" v-if="showLoader">
        <div class="spinner"></div>
      </div>
      
      <div v-if="with_video && !showVideoElementsHTML && !contentVideoTaken" class="container-btn-start-video" :style="{ width: width + 'px', height: height + 'px' }">
        <button 
          class="btn btn-primary btn-siguiente white--text v-btn v-btn--has-bg theme--light v-size--large main_color" type="button"
          @click="handleClickBtnStartVideo" 
        >
          <span class="v-btn__content">Iniciar Videodenuncia</span>
        </button>
      </div>

      <canvas 
        ref="canvasRef" 
        v-if="with_video && showElementsHtml && showVideoElementsHTML && !contentVideoTaken"
        class="container-area-main"
        :width="width" 
        :height="height" 
      />
      <video 
        ref="localVideoRef"
        v-if="with_video && showElementsHtml && showVideoElementsHTML && !contentVideoTaken" 
        autoplay 
        muted
        :width="width"
        :height="height"
        playsinline
        style="display: none;"
      />

      <video 
        ref="videoTakenFromServer" 
        class="video-recorded"
        v-if="showVideoWithEvidence && contentVideoTaken"
        :width="width"
        :height="height"  
        autoplay
      />

      <img
        ref="signatureTakenFromServer"
        class="signature_saved" 
        v-if="showSignatureImage"
        :width="width"
        :height="height" 
        alt="signature"
      >

      <div :style="{ width: width + 'px'}" class="container-actions-video-signature">
        <button 
            @click="clearCanva"
            v-if="showBtnClear"
            class="btn w-auto btn-primary white--text v-btn v-btn--has-bg theme--light v-size--small main_color" type="button"
          >
            <span class="v-btn__content">Limpiar</span>
        </button>

        <button 
            @click="saveResource"
            v-if="showBtnSave"
            class="btn w-auto btn-primary white--text v-btn v-btn--has-bg theme--light v-size--small main_color" type="button"
          >
            <span class="v-btn__content">Save</span>
        </button>

        <button 
            @click="seeResource"
            v-if="contentVideoTaken && !showVideoWithEvidence && !showSignatureImage"
            class="btn w-auto btn-primary white--text v-btn v-btn--has-bg theme--light v-size--small main_color" type="button"
          >
            <span class="v-btn__content">Ver</span>
        </button>

        <button 
            @click="againSign"
            v-if="(contentVideoTaken && showVideoWithEvidence) || showSignatureImage"
            class="btn w-auto btn-primary white--text v-btn v-btn--has-bg theme--light v-size--small main_color" type="button"
          >
            <span class="v-btn__content">¿Volver a firmar?</span>
        </button>
      </div>
    </v-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import * as Storage from '@/core/storage.js'

  export default {
    name: 'AutographSignature',

    props: ['width','height','with_video','field','stageId','formValues'],

    data() {
      return {
        isDrawing: false,
        showVideoElementsHTML: false,
        showBtnSave: false,
        showBtnClear: true,
        showVideoWithEvidence: false,
        showSignatureImage: false,
        showElementsHtml: true,
        showLoader: false,
        recorder: null,
        videoStream: null,
        recordedChunks: [],
        stream: null,
        contentVideoTaken: false,

        file_name_video:'',
        id_video:null,
        llave_video:'',
        force_token_video:'',

        file_name_signature:'',
        id_signature:null,
        llave_signature:'',
        force_token_signature:''
      };
    },

    watch: {

    },
    
    mounted() {
      this.setBackgroundWhenIsJustSignature();//Establecer un fondo blanco en el area de firmado cuando solo se requiera la firma sin el video
     if(this.field.value){
        this.file_name_video = this.field.value.video.file_name;
        this.id_video = this.field.value.video.id;
        this.llave_video = this.field.value.video.llave;
        this.force_token_video = this.field.value.video.force_token;
        
        this.file_name_signature = this.field.value.signature.file_name;
        this.id_signature = this.field.value.signature.id;
        this.llave_signature = this.field.value.signature.llave;
        this.force_token_signature = this.field.value.signature.force_token

        this.showBtnSave = false;
        this.showBtnClear = false;

        if(this.with_video){
          this.showVideoElementsHTML = true;
          this.contentVideoTaken = true;
        }

        this.seeResource()
     }
    },

    methods: {
      getClientPosition(e, canvas) {
        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        let x, y;

        if (e.touches) {
          x = e.touches[0].clientX;
          y = e.touches[0].clientY;
        } else {
          x = e.clientX;
          y = e.clientY;
        }

        x = (x - rect.left) * scaleX;
        y = (y - rect.top) * scaleY;
        return { offsetX: x, offsetY: y };
      },

      setBackgroundWhenIsJustSignature(){
        if(!this.with_video){//Si el valor es false, es decir, no se requiere video
          const canvas = this.$refs.signatureRef;
          const ctx = canvas.getContext('2d');
          ctx.fillStyle = 'white';
          ctx.fillRect(0,0,canvas.width,canvas.height);
          this.showBtnSave = true;
        }
      },

      startDrawing(e) {
        e.preventDefault();
        const canvas = this.$refs.signatureRef;
        const ctx = canvas.getContext('2d');
        ctx.strokeStyle = '#691C32';
        ctx.lineWidth = 3; 
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.beginPath();
        const { offsetX, offsetY } = this.getClientPosition(e, canvas);
        ctx.moveTo(offsetX, offsetY);
        this.isDrawing = true;
      },

      draw(e) {
        if (!this.isDrawing) return;
        const canvas = this.$refs.signatureRef;
        const ctx = canvas.getContext('2d');
        const { offsetX, offsetY } = this.getClientPosition(e, canvas);
        ctx.lineTo(offsetX, offsetY);
        ctx.stroke();
      },

      clearCanva() {
        const canvas = this.$refs.signatureRef;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      },

      stopDrawing() {
        this.isDrawing = false;
        const canvas = this.$refs.signatureRef;
        const ctx = canvas.getContext('2d');
        ctx.closePath();
      },

      handleClickBtnStartVideo(){
        this.showVideoElementsHTML = true;
        setTimeout(()=>{
          this.startCamera();
          this.startRecord();
        },500);
      },

      async startCamera() {
        if(this.$refs.canvasRef){ //Comienza a grabar solo si existe el canvas donde se va a renderizar el video que se esta obteniendo de la camara
          const canvas = this.$refs.canvasRef;
          const ctx = canvas.getContext('2d');
          const video = this.$refs.localVideoRef;

          try {
            this.stream = await navigator.mediaDevices.getUserMedia({ video: true });
            video.srcObject = this.stream;

            video.addEventListener('loadedmetadata', () => {
              video.play();
            });

            const drawFrame = () => {
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              if(this.$refs.signatureRef){
                ctx.drawImage(this.$refs.signatureRef, 0, 0, canvas.width, canvas.height);
              }
              requestAnimationFrame(drawFrame);
            };

            video.addEventListener('play', drawFrame);

            this.showBtnSave = true; //Reasignar a la variable a verdadero para renderizar boton de "limpiar" y "finalizar"

          } catch (error) {
            console.error("Error al acceder a la cámara:", error);
          }
        }  
      },


      startRecord(){
        const canvas = this.$refs.canvasRef; //Seleccionamos el canvas que contiene o dibuja la firma y lo graba la camara
        this.videoStream = canvas.captureStream(30);//Asignamos en una variable toda el flujo del stream que contiene el canvas
        this.recorder = new MediaRecorder(this.videoStream);//Creamos un grabador que contendrael flujo del stream

        this.recorder.ondataavailable = (event) => {//Cuando haya datos disponibles en el recorder, almacenar la data o frames
          if (event.data.size > 0) {
            this.recordedChunks.push(event.data);
          }
        };

        this.recorder.start(1000);//Comienza la grabacion
      },


      saveResource(){
        this.showBtnClear = false;
        this.showBtnSave = false;
        this.showElementsHtml = false;//Ocultar los dos canvas y el video
        this.showLoader = true;//Mostrar una animacion de loader
        this.showSignatureImage = false;

        this.sendDataToServer(this.with_video);
      },

      seeResource(){
        if(this.with_video){
          this.seeVideoResource();
        }else{
          this.seeSignatureResource();
        }
      },

      seeSignatureResource(){
        this.showSignatureImage = true;
        setTimeout(()=>{
          this.getImage(this.file_name_signature,this.id_signature,this.llave_signature,this.force_token_signature)
        },200)
      },


      seeVideoResource(){
        this.showVideoWithEvidence = true;
        this.contentVideoTaken = true;
        setTimeout(()=>{
          this.getVideo(this.file_name_video,this.id_video,this.llave_video,this.force_token_video)
        },200)
      },

      againSign(){
        this.contentVideoTaken = false;
        this.showElementsHtml = true;
        this.showSignatureImage = false

        let deleted = false;

        if(this.with_video){
          try {
            this.deleteFile(this.field.id, this.stageId, this.file_name_video)
            this.deleteFile(this.field.id, this.stageId, this.file_name_signature) 
            deleted = true;
          } catch (error) {
            console.log(error)
          }
        }else{
          try {
            this.deleteFile(this.field.id, this.stageId, this.file_name_signature) 
            deleted = true
            this.showBtnSave = true
          } catch (error) {
            console.log(error)
          }
        }

        if(this.with_video && deleted){
          this.showVideoWithEvidence = false;
          this.showVideoElementsHTML = true;
          setTimeout(()=>{
            this.startCamera();
            this.startRecord();
          },500);
        }
      },


      deleteFile(id,stageId,file_name){
        let token = Storage.getItem('token')

        const headers = {
            "Content-Type": 'application/xml',
            'Authorization': `Bearer ${token}`
        };

        axios.delete(`https://agentes.pgjhidalgo.gob.mx/uploader/datos/${id}/${stageId}?filename=${file_name}`,{ headers })
          .then(response => {
            console.log(response)
            console.log("File deleted succesfully")
          })
          .catch(error => {
            console.log('Error deleting file',error)
          })
      },

      getImage(file_name,id,llave,force_token){
        try {
          this.$refs.signatureTakenFromServer.src = `https://agentes.pgjhidalgo.gob.mx/uploader/datos_get/${file_name}?id=${id}&token=${llave}&force_token=${force_token}`
        } catch (error) {
          console.log(error)
        }
      },

      getVideo(file_name,id,llave,force_token){
        try {
          this.$refs.videoTakenFromServer.src = `https://agentes.pgjhidalgo.gob.mx/uploader/datos_get/${file_name}?id=${id}&token=${llave}&force_token=${force_token}`
        } catch (error) {
          console.log(error)
        }

      },

      async sendDataToServer(with_video){
        const canvas = this.$refs.signatureRef;
        if(canvas){
          canvas.toBlob((blob) => {
            const formData = new FormData();
            formData.append('signature', blob, `signature.png`);

            if(with_video){

              this.recorder.stop();
              this.stream.getTracks().forEach(track => track.stop());

              const blob_video = new Blob(this.recordedChunks, { type: 'video/webm' });
              formData.append('video', blob_video, `video.webm`);
            }

            let token = Storage.getItem('token')

            const headers = {
                "Content-Type": 'application/xml',
                'Authorization': `Bearer ${token}`
            };

            axios.post(`https://agentes.pgjhidalgo.gob.mx/uploader/video_signature/${this.field.id}/${this.stageId}`, formData, { headers })//Sube video / firma
                .then((response) => {

                  this.formValues[this.field.nombre] = JSON.stringify(response.data)

                  this.contentVideoTaken = true;
                  this.showLoader = false; 

                  this.file_name_video = response.data.video.file_name;
                  this.id_video = response.data.video.id;
                  this.llave_video = response.data.video.llave;
                  this.force_token_video = response.data.video.force_token;
                 
                  this.file_name_signature = response.data.signature.file_name;
                  this.id_signature = response.data.signature.id;
                  this.llave_signature = response.data.signature.llave;
                  this.force_token_signature = response.data.signature.force_token

                  this.recordedChunks = []
                })
                .catch((error) => {
                  console.error('Error saving files:', error);
                }
            );
          },'image/png')
        }
      },

      stopRecording(){
        this.recorder.stop();

        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
        this.$refs.localVideoRef.srcObject = null;

      }

    }
  }
</script>

<style scoped>
  .container-autograph-signature {
    position: relative;
  }
  .margin-top{
    margin-bottom: 0.5rem !important;
  }
  .container-btn-start-video{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 7;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
  }
  .container-signature {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    padding: 0 !important;
    width:100%;
    height:100%;
  }
  .video-recorded{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    padding: 0 !important;
    width:100%;
    height:100%;
  }
  .signature_saved{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    padding: 0 !important;
    width:100%;
    height:100%;
  }
  .container-area-main {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    padding: 0 !important;
    width:100%;
    height:100%;
  }
  .container-actions-video-signature{
    position: absolute;
    bottom: 0.5rem;
    left: 0;
    z-index: 5;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  
  .loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 4;
  }

  .spinner {
    border: 5px solid rgba(0, 0, 0, 0.1);
    border-left-color: #194a7f; /* Cambia el color aquí */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
